<script>
export default {
  name: "RotationCheck",
  props: {
    imageFile: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      image: null,
      canvas: null,
      ctx: null,
      currentRotation: 0,
    };
  },
  watch: {
    currentRotation(v) {
      if (v >= 4 || v <= -4) {
        this.currentRotation = 0;
      } else {
        this.rotate(v);
      }
    },
  },
  async mounted() {
    this.preprocessImage();
  },
  methods: {
    preprocessImage() {
      var _URL = window.URL || window.webkitURL;
      var img = new Image();

      img.src = _URL.createObjectURL(this.imageFile);
      img.onload = () => {
        this.image = img;
        // setup canvas
        this.canvas = this.$refs.checkCanvas;
        this.canvas.width = this.image.width;
        this.canvas.height = this.image.height;
        this.ctx = this.canvas.getContext("2d");
        this.fixOrientation();
      };
    },
    // from http://stackoverflow.com/a/32490603
    fixOrientation() {
      var currentOrientation;
      this.getOrientation(this.imageFile, (orientation) => {
        currentOrientation = orientation;
      });

      var height = this.image.height;
      var width = this.image.width;

      if (4 < currentOrientation && currentOrientation < 9) {
        this.canvas.width = height;
        this.canvas.height = width;
      }

      // transform context before drawing image
      switch (currentOrientation) {
        case 2:
          this.ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          this.ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          this.ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          this.ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          this.ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          this.ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          this.ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }
      this.ctx.drawImage(this.image, 0, 0);
    },
    getOrientation(file, callback) {
      var reader = new FileReader();

      reader.onload = function (event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        var length = view.byteLength,
          offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16((offset += 6), false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++)
              if (view.getUint16(offset + i * 12, little) == 0x0112)
                return callback(view.getUint16(offset + i * 12 + 8, little));
          } else if ((marker & 0xff00) != 0xff00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
    },
    rotate(dir) {
      var image = this.image;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.save();
      var tmp = this.canvas.width;
      this.canvas.width = this.canvas.height;
      this.canvas.height = tmp;
      this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
      this.ctx.rotate((90 * dir * Math.PI) / 180);
      this.ctx.drawImage(
        image,
        -this.canvas.width / 2,
        -this.canvas.height / 2
      );
      this.ctx.restore();
    },
  },
};
</script>

<template>
  <v-container fluid>
    <p class="text-body-1 mt-n12 mb-6">
      We tried to fix the rotation for you, make sure
      <br />it is correct and/or fix it here
    </p>
    <v-row class="justify-center align-center">
      <canvas
        ref="checkCanvas"
        style="height: 300px; width: 300px; object-fit: contain"
      />
    </v-row>
    <v-row class="justify-center mt-6">
      <v-btn icon large class="mx-12" @click="currentRotation--">
        <v-icon large>$rotateLeft</v-icon>
      </v-btn>
      <v-btn icon large class="mx-12">
        <v-icon large @click="currentRotation++">$rotateRight</v-icon>
      </v-btn>
    </v-row>
    <v-btn
      text
      color="primary"
      class="float-right"
      @click="$emit('confirm', currentRotation, image)"
      >Confirm</v-btn
    >
  </v-container>
</template>

<style></style>
